export const getData = async () => fetch("https://www.seatingsymposium.us/app/rest/events").then(response => response.json())